module.exports = __webpack_public_path__ + "img/nicklas-andreasson.344b0a0d.jpeg";